import React from 'react';
import { COPY } from '../../contracts/copyMap';
import ProOfferPanel from '../billing/ProOfferPanel';

// The routine paywall's resting state — what stays on screen after NOT NOW
// dismisses UnlockGateModal.
//
// ⚠ THE SCRIM IS LOAD-BEARING, not decoration. This sits on top of
// RoutineLockedPreview, which is a full-bleed field of blurred skeleton cards.
// Without an opaque backdrop the card reads as one more blurred tile and the
// offer disappears into the texture — that was the first version's problem.
// The card itself brings a solid fill, a border and a lift shadow; this
// wrapper brings the scrim that pushes the preview back. Do not make either
// transparent.
//
// It renders OUTSIDE RoutineLockedPreview in the DOM on purpose. The preview is
// aria-hidden decoration, so once the modal closes this panel is the only thing
// a screen reader can find on the surface — inside the preview it would be
// invisible to assistive tech and the page would be a silent dead end.
//
// The CTA goes straight to checkout rather than reopening the modal: a button
// above trial terms should do the thing it names.
export default function RoutinePaywallPanel() {
  return (
    // Scroll container + `min-h-full` inner flex, NOT a centred flex item on
    // the absolute box. The preview underneath sets this box's height, and a
    // centred child taller than its container overflows in BOTH directions —
    // the top gets clipped and no amount of scrolling reaches it. This pattern
    // centres when there is room and scrolls when there is not.
    <div
      className="absolute inset-0 overflow-y-auto bg-obsidian/50"
      data-testid="routine-paywall-panel"
    >
      <div className="flex min-h-full items-center justify-center px-5 py-8">
      <ProOfferPanel
        headline={COPY.UNLOCK_GATE_HEADLINE_ROUTINE}
        body={COPY.UNLOCK_GATE_BODY_ROUTINE}
        ctaLabel={COPY.UNLOCK_GATE_ROUTINE_CTA}
        terms={COPY.UNLOCK_GATE_TRIAL_TERMS}
        label="RoutinePaywallPanel"
        ctaTestId="routine-paywall-cta"
      />
      </div>
    </div>
  );
}
